var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"bg-main",attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-alert',[_vm._v("Comming soon")])],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }